<template>
  <div>
    <div class="header">
      <div class="d-flex">
        <b>Дашборд:</b> <b class="org">{{org_data.org_name||""}}</b>
<!--        <a href=""><b>sogaz.ru</b> <i class="bi bi-box-arrow-up-right"></i></a>-->
      </div>
      <div class="filters">
<!--        {{res}}-->
        <span>Последняя проверка: {{ $moment(org_data.last_parser).startOf('hour').fromNow() }}</span>
        <div class="filter">
          <span>Площадок:</span>
          <span>{{org_data.resource_count}}</span>
<!--          <div class="dropdown">-->
<!--            <button class="" type="button" data-bs-toggle="dropdown" aria-expanded="false" data-bs-auto-close="outside">-->
<!--              <div class="filter-hint"> {{ resources.length }}</div>-->
<!--            </button>-->
<!--            <ul class="dropdown-menu">-->
<!--              <li v-for="resource in resources">-->
<!--                <div class="name">-->
<!--                  <div class="resource-checkbox">-->
<!--                    <input type="checkbox" name="" :id="`base-filter-${resource.id}`" v-model="resource.check">-->
<!--                    <label :for="`base-filter-${resource.id}`">-->
<!--                    <span :style="{backgroundColor: resource.color, borderColor: resource.color}" class="check"><i-->
<!--                        class="bi bi-check"></i></span>-->
<!--                      {{ resource.name || resource.domain }}</label>-->
<!--                  </div>-->
<!--                </div>-->
<!--              </li>-->
<!--              <li>-->
<!--            <button class="btn btn-primary">Применить</button></li>-->
<!--            </ul>-->

<!--          </div>-->
        </div>
        <span>
          <button class="btn btn-sm btn-secondary" disabled>Поделиться</button>
          <router-link :to="{name: 'reviews_monitor_setting'}" active-class="active" class="btn btn-sm btn-primary"><i
              class="bi bi-gear"></i>
        </router-link>
        </span>

      </div>
    </div>

    <ul class="nav nav-underline">
      <li class="nav-item">
        <router-link :to="{name: 'reviews_monitor'}" active-class="active" class="nav-link">Обзор</router-link>
      </li>
      <li class="nav-item">
        <router-link :to="{name: 'reviews_monitor_reviews'}" active-class="active" class="nav-link">Отзывы</router-link>
      </li>
      <li class="nav-item">
        <router-link :to="{name: 'reviews_monitor_parsers'}" active-class="active" class="nav-link">Парсеры
        </router-link>
      </li>
      <li class="nav-item">
        <router-link :to="{name: 'reviews_monitor_report'}" active-class="active" class="nav-link">Отчёты</router-link>
      </li>
      <li class="nav-item">
        <router-link :to="{name: 'reviews_monitor_setting'}" active-class="active" class="nav-link">Настройки
        </router-link>
      </li>
    </ul>
  </div>

</template>

<script>

import {ReviewApi} from "@/api/reviews";

export default {
  name: 'ReviewHead',
  props: {},
  data() {
    return {
      org_data: {},
      resources: []
    }
  },


  mounted: function () {
    ReviewApi.review_info().then(response=>this.org_data = response)

    // ReviewApi.resource_list().then(response => {
    //   this.resources = response;
    //   this.resources.map(x => {
    //     if (!x.color) x.color = `#${Math.floor(Math.random() * 16777215).toString(16).padStart(6, '0')}`;
    //     x.check = true
    //   })
    //
    //     // if (!this.res.length) this.$store.dispatch('setResources', this.resources.map(x=>x.id));
    // })
  },
  computed: {
    // res(){
    //   return this.$store.getters.reviewResources;
    // }
  },

  methods: {
    // s
  }
}

</script>
<style scoped lang="scss">
.header {
  display: flex;
  gap: 15px;
  flex-direction: column;
  padding-bottom: 20px;

  .d-flex {
    gap: 8px;

    b {
      font-size: 20px;

      &.org {
        color: rgba(0, 109, 202, 1);
      }
    }

    a {
      color: rgba(108, 110, 121, 1);
      display: flex;
      gap: 4px;

      &:hover {
        text-decoration: none;
      }

      i {
        font-size: 14px;
        font-weight: bold;
        color: rgba(169, 171, 182, 1);
      }
    }
  }

  .dropdown {
    button {
      background: transparent;
      border: 0;
    }
  }

  .filters {
    display: flex;
    gap: 24px;
    font-size: 14px;
    align-items: center;

    span:last-child {
      margin-left: auto;
      display: flex;
      gap: 8px;
    }

    .filter {
      display: flex;
      gap: 4px;

      .filter-hint {
        color: rgba(108, 110, 121, 1);
        border-bottom: 1px dashed rgb(108, 110, 121);
        cursor: pointer;

        &:hover {
          color: rgb(60, 60, 67);
          border-bottom: 1px dashed rgb(60, 60, 67);
        }
      }
    }

  }
}

.dropdown-menu.show {
  padding: 15px 10px;
  gap: 10px;
  display: flex;
  flex-direction: column;
}

</style>

